import {
  FileText,
  FileImage,
  FileSpreadsheet,
  FileVideo,
  File,
} from "lucide-react";
import { cn } from "@/lib/utils";

interface FileTypeIconProps {
  mimeType: string;
  className?: string;
}

export const FileTypeIcon = ({ mimeType, className }: FileTypeIconProps) => {
  const getIcon = (mimeType: string) => {
    if (
      mimeType.includes("pdf") ||
      mimeType.includes("text") ||
      mimeType.includes("document")
    ) {
      return FileText;
    }
    if (mimeType.includes("image")) {
      return FileImage;
    }
    if (
      mimeType.includes("excel") ||
      mimeType.includes("spreadsheet") ||
      mimeType.includes("csv")
    ) {
      return FileSpreadsheet;
    }
    if (mimeType.includes("video")) {
      return FileVideo;
    }
    return File;
  };

  const IconComponent = getIcon(mimeType);

  return <IconComponent className={cn("h-4 w-4", className)} />;
};
